import React from 'react';
import styled from 'styled-components';
import Utils from 'shared/utils/index';
import useAssetPreloader from 'shared/components/AssetPreloader/useAssetPreloader';
import { ASSET_KEY, assetSource } from 'shared/utils/assetSource';

const DefaultPreloader = () => {
  const { percentLoaded } = useAssetPreloader();

  const LoadingBarContainerClass = 'AssetPreloaderLoadingBar';

  return (
    <ContainerBackground className="AssetPreloader">
      <div className={LoadingBarContainerClass + (Utils.ieVersion() !== 0 ? ' ieHack' : '')}>
        <img alt="" className="ExpBarInset" src={assetSource(ASSET_KEY.LOADING_BAR_INSET)} />
        <img
          alt=""
          src={assetSource(ASSET_KEY.LOADING_BAR_FILL)}
          className="ExpBarInner"
          style={{ width: `${percentLoaded > 3 ? percentLoaded - 2 : 3}%` }}
        />
      </div>
    </ContainerBackground>
  );
};

export default DefaultPreloader;

const ContainerBackground = styled.div`
  background-image: url(${assetSource(ASSET_KEY.LOADING_SCREEN)});
  ${({ theme }) => theme.AssetPreloader.ContainerBackground};
`;

